import { css } from "@emotion/css";
import { borderRadius, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import type { ReactNode } from "react";
interface PolicyBannerProps {
    heading: string;
    subHeading: ReactNode;
    accessories?: ReactNode;
}
export function PolicyBanner({ heading, subHeading, accessories }: PolicyBannerProps): ReactNode {
    return (<div className={styles.templateInfoContainer}>
            <div className={styles.innerContainer}>
                <div className={styles.templateDetails}>
                    <div className={styles.heading}>{heading}</div>
                    <div className={styles.subHeading}>{subHeading}</div>
                </div>
                {accessories}
            </div>
        </div>);
}
const styles = {
    templateInfoContainer: css({
        display: "flex",
        alignItems: "center",
        gap: space[12],
        backgroundColor: themeTokens.color.background.secondary.default,
        borderRadius: borderRadius.small,
        border: `1px solid ${themeTokens.color.border.primary}`,
        padding: space[12],
    }),
    templateDetails: css({
        display: "flex",
        flexDirection: "column",
        flex: 1,
    }),
    heading: css({
        font: text.body.bold.medium,
        color: themeTokens.color.text.primary,
    }),
    subHeading: css({
        font: text.body.regular.small,
        color: themeTokens.color.text.secondary,
    }),
    innerContainer: css({
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
    }),
};
